import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseeReturnDetailsAsync } from "./ILicenseeReturns";
import { GetLicenseDetailsAsync } from "./LicenceDetails";

export interface IRequestForInformation {
  rfiid: string;
  type: string;
  licenceid: string;
  reference: string;
  status: string;
  datesubmitted: string;
  duedate: string;
  subject: string;
  responsereceiveddate: string;
  question: string;
  response: string;
  licenseesubmisionid: string; // LR Id
  profileNo: string;
  licence_regno: string;
  licensee_return_reference: string; //LR's ref no.
}

export const GetRequestsForInformationFromLicenseeReturnFetchUrl = (
  licenseeReturnId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/LicenseeReturns/rfilistbylrid?lr_id=${licenseeReturnId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/rfis-by-licensee-return`;
  }

  return url;
};

export async function GetRequestForInformationDetailsAsync(
  requestForInformationId: string
): Promise<IRequestForInformation> {
  var url = `${API_URL}/LicenseeReturns/rfibyid?rfi_id=${requestForInformationId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/rfi-details`;
  }

  var response = await fetch(url);
  var body = <IRequestForInformation>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);
  const licenseeReturn = await GetLicenseeReturnDetailsAsync(
    body.licenseesubmisionid
  );

  return <IRequestForInformation>{
    rfiid: body.rfiid,
    type: body.type,
    licenceid: body.licenceid,
    reference: body.reference,
    status: body.status,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    subject: body.subject,
    responsereceiveddate: formatDate(body.responsereceiveddate),
    question: body.question,
    response: body.response,
    licenseesubmisionid: body.licenseesubmisionid,
    profileNo: licenceDetails.licenceprofile_number,
    licence_regno: licenceDetails.reg_no, // LR,
    licensee_return_reference: licenseeReturn.reference,
  };
}
